"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _BaseTheme = _interopRequireDefault(require("../../Themes/BaseTheme"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const Executive = () => /*#__PURE__*/_react.default.createElement("svg", {
  viewBox: "0 0 40 40"
}, /*#__PURE__*/_react.default.createElement("path", {
  d: "M15.6 32.8l-.9-10.4-1-.5-2-11.5h3c-.3-.7-.5-1.4-.5-2.2 0-3.2 2.6-5.7 5.7-5.7s5.7 2.6 5.7 5.7c0 .8-.2 1.5-.5 2.2h3l-2 11.5-1 .5-.9 10.4-4.2 2.7-4.4-2.7zm8.6-12.5l1.3-7.6h-3.3L20 15.1l-2.1-2.3h-3.4l1.3 7.6 4.2 1.9 4.2-2zm-.8-12.1c0-1.9-1.5-3.4-3.4-3.4s-3.4 1.5-3.4 3.4 1.5 3.4 3.4 3.4c1.9.1 3.4-1.5 3.4-3.4zm-1.2 23.3l.8-9.1-3 1.3-3-1.3.8 9.1 2.2 1.3 2.2-1.3z",
  fill: _BaseTheme.default.colors.gray
}));

var _default = Executive;
exports.default = _default;